export const environment = {
  production: true,
  sentry: {
    enabled: true,
    dsn: 'https://4772c162349348a08dc47494e73e7740@o147357.ingest.sentry.io/5382184',
  },
};
